import styled from "styled-components";

export const InsightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  color: #333;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const InsightContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding-top: 8px;

  & > div {
    width: 100%;
  }
`;

export const ListItem = styled.div`
  display: list-item;
  list-style: disc outside;
  margin-inline-start: 1.25rem;
  color: ${(props) => props.theme.colors.davysGrey};
`;

export const ErrorWrapper = styled.div`
  padding: 24px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const EmptyWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  padding: 24px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.highClearGray};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.white};
  margin: 0 auto;
`;
